import * as Yup from "yup";
import { isNil } from "ramda";

export const editSchema = Yup.object({
  attributes: Yup.object({
    CommonName: Yup.string().required("Common Name is required"),
    RevocationDate: Yup.string().nullable(),
    RevocationReason: Yup.string()
      .nullable()
      .notRequired()
      .when("RevocationDate", {
        is: (val) => !isNil(val),
        then: () =>
          Yup.string()
            .required("Revocation Reason is required")
            .nullable(),
        otherwise: () => Yup.string().notRequired(),
      }),
  }),
});

export const newSchema = Yup.object({
  attributes: Yup.object({
    Description: Yup.string().required("Description is required"),
    CA: Yup.boolean().required("Certificate Type is required"),
    CSR: Yup.string(),
    CommonName: Yup.string()
      .nullable()
      .notRequired()
      .when("CA", {
        is: true,
        then: () =>
          Yup.string()
            .required("Common Name is required")
            .nullable(),
        otherwise: () => Yup.string().notRequired(),
      })
      .when(["CA", "CSR"], {
        is: (CA, CSR) => {
          return !CA && isNil(CSR);
        },
        then: () =>
          Yup.string()
            .required("Common Name is required, when CSR has not been uploaded")
            .nullable(),
        otherwise: () => Yup.string().notRequired(),
      }),
  }),
});
